import React from 'react'
import { Box, Text, useColorMode } from '@chakra-ui/core';

const Footer = () => {
    const { colorMode } = useColorMode();
    return (
        <div>
            <Box p={5} textAlign="center" bg={colorMode === "dark" ? "gray.900" : "green.300"} mt={30}>
                <Text>Made with Love by Salyd Team | &#169; 2020  </Text>
            </Box>
        </div>
    )
}

export default Footer
